import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';

export interface MediaDto {
  mediaId: string;
  entityType: string;
  entityId: string;
  mediaType: string;
  url: string;
  fileName?: string;
  contentType?: string;
  displayOrder: number;
  isActive: boolean;
  metadata?: string;
}

export interface ErrorDto {
  statusCode?: number;
  messages?: string[];
}

export interface MediaResponse {
  isSuccess: boolean;
  value?: MediaDto;
  error?: ErrorDto;
}

export interface MediaListResponse {
  isSuccess: boolean;
  total: number;
  values: MediaDto[];
  error?: ErrorDto;
}

export interface MediaDeleteResponse {
  isSuccess: boolean;
  value?: boolean;
  error?: ErrorDto;
}

@Injectable({
  providedIn: 'root'
})
export class LocationMediaService {
  private baseUrl = `${environment.apiUrl}/api/v2/booking/locations`;

  constructor(private http: HttpClient) {}

  getMediaByLocation(locationId: string): Observable<MediaListResponse> {
    return this.http.get<MediaListResponse>(`${this.baseUrl}/${locationId}/media`);
  }

  uploadMedia(
    locationId: string,
    mediaType: string,
    file: File,
    displayOrder: number = 1,
    metadata?: string
  ): Observable<MediaResponse> {
    console.log('=== LocationMediaService.uploadMedia ===');
    console.log('LocationId:', locationId);
    console.log('MediaType:', mediaType);
    console.log('File:', file.name, 'Size:', file.size, 'Type:', file.type);
    console.log('DisplayOrder:', displayOrder);
    console.log('Upload URL:', `${this.baseUrl}/${locationId}/media/upload`);
    
    const formData = new FormData();
    formData.append('mediaType', mediaType);
    formData.append('file', file);
    formData.append('displayOrder', displayOrder.toString());
    if (metadata) {
      formData.append('metadata', metadata);
    }

    return this.http.post<MediaResponse>(
      `${this.baseUrl}/${locationId}/media/upload`,
      formData
    );
  }

  deleteMedia(locationId: string, mediaId: string): Observable<MediaDeleteResponse> {
    return this.http.delete<MediaDeleteResponse>(`${this.baseUrl}/${locationId}/media/${mediaId}`);
  }
}
